import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import HeaderDescription from "../../../../components/commons/HeaderDescription";
import { adminOnboardingCompanyInfoSchema } from "../../../../validations/adminOnboarding";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import mobioApi from "../../../../services";
import { toastMessage } from "../../../../helpers/toastMessage";

const CompanyInformation = ({ onboardingData, token }) => {
  return (
    <div>
      <div className="width-ful">
        <Formik
          initialValues={{
            companyName: onboardingData
              ? onboardingData?.user?.companyName || ""
              : "",
            companyAddress: onboardingData
              ? onboardingData?.user?.companyAddress || ""
              : "",
            companyPostCode: onboardingData
              ? onboardingData?.user?.companyPostCode || ""
              : "",
            companyCity: onboardingData
              ? onboardingData?.user?.companyCity || ""
              : "",
            companyRegistrationNumber: onboardingData
              ? onboardingData?.user?.companyRegistrationNumber || ""
              : "",
            companyVATNumber: onboardingData
              ? onboardingData?.user?.companyVATNumber || ""
              : "",
            IBAN: onboardingData ? onboardingData?.user?.IBAN || "" : "",
            bankAccountHolderName: onboardingData
              ? onboardingData?.user?.bankAccountHolderName || ""
              : "",
          }}
          validationSchema={adminOnboardingCompanyInfoSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const payload = {
                userId: onboardingData?.user?.id,
                updateStatus: "companyInfo",
                companyName: values.companyName,
                companyAddress: values.companyAddress,
                companyPostCode: values.companyPostCode,
                companyCity: values.companyCity,
                companyRegistrationNumber: values.companyRegistrationNumber,
                companyVATNumber: values.companyVATNumber,
                IBAN: values.IBAN,
                bankAccountHolderName: values.bankAccountHolderName,
              };

              const api = mobioApi(token);
              const response = await api.onboardingPersonalInfoUpdate(payload);
              if (response?.data?.success) {
                toastMessage(
                  "success",
                  response?.data?.msg || "User data update successfully"
                );

                onboardingData.user.companyName = values.companyName;
                onboardingData.user.companyAddress = values.companyAddress;
                onboardingData.user.companyPostCode = values.companyPostCode;
                onboardingData.user.companyCity = values.companyCity;
                onboardingData.user.companyRegistrationNumber =
                  values.companyRegistrationNumber;
                onboardingData.user.companyVATNumber = values.companyVATNumber;
                onboardingData.user.IBAN = values.IBAN;
                onboardingData.user.bankAccountHolderName =
                  values.bankAccountHolderName;
              }
            } catch (error) {
              toastMessage("error", error?.response?.data.msg);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <div className="bg-white main-section-spacing-md border-radius-8">
                <HeaderDescription
                  heading="Company Information"
                  description="Fill in your company details below."
                />

                <div className="mt-20">
                  {/* Row 1 */}
                  <div className="flex align-item-center gap-32">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Company Name</label>
                        <Field
                          type="text"
                          name="companyName"
                          placeholder="Enter Company Name"
                          className="type-input-focus"
                          value={values.companyName}
                        />
                        <ErrorMessage
                          name="companyName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Company Address</label>
                        <Field
                          type="text"
                          name="companyAddress"
                          placeholder="Enter Company Address"
                          className="type-input-focus"
                          value={values.companyAddress}
                        />
                        <ErrorMessage
                          name="companyAddress"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Post Code</label>
                        <Field
                          type="text"
                          name="companyPostCode"
                          placeholder="Enter Post Code"
                          className="type-input-focus"
                          value={values.companyPostCode}
                        />
                        <ErrorMessage
                          name="companyPostCode"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>City</label>
                        <Field
                          type="text"
                          name="companyCity"
                          placeholder="Enter City"
                          className="type-input-focus"
                          value={values.companyCity}
                        />
                        <ErrorMessage
                          name="companyCity"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Registration Number</label>
                        <Field
                          type="text"
                          name="companyRegistrationNumber"
                          placeholder="Enter Company Registration Number"
                          className="type-input-focus"
                          value={values.companyRegistrationNumber}
                        />
                        <ErrorMessage
                          name="companyRegistrationNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>VAT Number</label>
                        <Field
                          type="text"
                          name="companyVATNumber"
                          placeholder="Enter Company VAT Number"
                          className="type-input-focus"
                          value={values.companyVATNumber}
                        />
                        <ErrorMessage
                          name="companyVATNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>IBAN</label>
                        <Field
                          type="text"
                          name="IBAN"
                          placeholder="Enter IBAN"
                          className="type-input-focus"
                          value={values.IBAN}
                        />
                        <ErrorMessage
                          name="IBAN"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Bank Account Holder Name</label>
                        <Field
                          type="text"
                          name="bankAccountHolderName"
                          placeholder="Enter Bank Account Holder Name"
                          className="type-input-focus"
                          value={values.bankAccountHolderName}
                        />
                        <ErrorMessage
                          name="bankAccountHolderName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex align-item-center justify-content-end mt-42">
                    <MOButtonV2
                      type="submit"
                      text="SAVE COMPANY INFORMATION"
                      textColor="#ffffff"
                      radius={4}
                      widthSize={200}
                      height={42}
                      padding={"10px 12px 10px 12px"}
                      backgroundColor="#29AEE6"
                      fontSize={12}
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CompanyInformation;
